export default "__VITE_ASSET__6d6c131e__"